var ke = Object.defineProperty;
var _e = (r, e, t) => e in r ? ke(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var v = (r, e, t) => (_e(r, typeof e != "symbol" ? e + "" : e, t), t);
import F from "axios";
import { defineComponent as $, ref as A, computed as Ce, openBlock as b, createElementBlock as R, normalizeStyle as le, withDirectives as q, normalizeClass as ce, vShow as N, createCommentVNode as Ee, createVNode as ue, watch as Se, onMounted as Ae, createElementVNode as H, createBlock as re, pushScopeId as Re, popScopeId as Te, createApp as de, reactive as he, toRefs as pe } from "vue";
var De = Object.defineProperty, Ue = (r, e, t) => e in r ? De(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, ne = (r, e, t) => (Ue(r, typeof e != "symbol" ? e + "" : e, t), t);
let g = class extends Error {
  constructor(r, e = null, t = null) {
    super(r), ne(this, "context"), ne(this, "prev"), this.name = "CgError", this.context = e ?? null, this.prev = t ?? null;
  }
};
const Oe = "https://payments.comgate.cz";
F.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
F.defaults.headers.common["X-Cg-Origin"] = window.location.origin;
function V(r, e = 200, t = {}, n = {}) {
  return new Promise((o, i) => {
    W(
      {
        url: r,
        method: "GET",
        params: t
      },
      e,
      o,
      i,
      ye(n)
    );
  });
}
function C(r, e = 200, t = {}, n = {}, o = {}) {
  return new Promise((i, s) => {
    W(
      {
        url: r,
        params: t,
        data: n,
        method: "POST"
      },
      e,
      i,
      s,
      ye(o)
    );
  });
}
function ye(r) {
  return {
    checkSuccessParam: r.checkSuccessParam !== !1
    // if TRUE response must have {"success": true}
  };
}
function W(r, e = 200, t, n, o, i = !1) {
  if (!r.url)
    throw new g("Missing URL");
  r.url = qe(r.url), F(r).then((s) => {
    var l;
    if (Array.isArray(e) && (e.length !== 2 || e[0] > e[1]) && console.warn("Invalid successCode array " + JSON.stringify(e) + " the first number must be lower or equal than the second one"), (Array.isArray(e) ? s.status >= e[0] && s.status <= e[1] : s.status === e) && (o.checkSuccessParam && ((l = s.data) == null ? void 0 : l.success) === !0 || !o.checkSuccessParam)) {
      delete s.data.success, t(s.data);
      return;
    }
    return Promise.reject({
      valid: !1,
      response: s
    });
  }).catch((s) => {
    var l, c;
    const m = (s == null ? void 0 : s.code) === "ETIMEDOUT" || ((l = s == null ? void 0 : s.response) == null ? void 0 : l.code) === "ETIMEDOUT" || ((c = s == null ? void 0 : s.error) == null ? void 0 : c.code) === "ETIMEDOUT";
    let h, d;
    if ((s == null ? void 0 : s.valid) === !1 ? (h = "Invalid response validation", d = s == null ? void 0 : s.response) : (h = (s == null ? void 0 : s.toString()) ?? "Unknown error", typeof s == "object" && "response" in s && typeof s.response == "object" ? d = s.response : d = s), m && !i) {
      W(r, e, t, n, o, !0);
      return;
    }
    n({
      message: h,
      status: (d == null ? void 0 : d.status) ?? null,
      expectedStatus: e,
      requiredSuccessResponseParam: o.checkSuccessParam,
      data: (d == null ? void 0 : d.data) ?? null,
      // request: res?.request ?? null,
      headers: (d == null ? void 0 : d.headers) ?? null,
      // config: res?.config,
      retries: i ? 1 : 0
      // response se sem dávat nemusí, protože je rozbalený (status, data, config)
    });
  });
}
function qe(r) {
  let e = r;
  return e.startsWith("/") && (e = Oe + e), e;
}
const Ne = typeof btoa == "function", z = typeof Buffer == "function";
typeof TextDecoder == "function" && new TextDecoder();
const oe = typeof TextEncoder == "function" ? new TextEncoder() : void 0, Le = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", S = Array.prototype.slice.call(Le);
((r) => {
  let e = {};
  return r.forEach((t, n) => e[t] = n), e;
})(S);
const w = String.fromCharCode.bind(String);
typeof Uint8Array.from == "function" && Uint8Array.from.bind(Uint8Array);
const xe = (r) => r.replace(/=/g, "").replace(/[+\/]/g, (e) => e == "+" ? "-" : "_"), Me = (r) => {
  let e, t, n, o, i = "";
  const s = r.length % 3;
  for (let l = 0; l < r.length; ) {
    if ((t = r.charCodeAt(l++)) > 255 || (n = r.charCodeAt(l++)) > 255 || (o = r.charCodeAt(l++)) > 255)
      throw new TypeError("invalid character found");
    e = t << 16 | n << 8 | o, i += S[e >> 18 & 63] + S[e >> 12 & 63] + S[e >> 6 & 63] + S[e & 63];
  }
  return s ? i.slice(0, s - 3) + "===".substring(s) : i;
}, me = Ne ? (r) => btoa(r) : z ? (r) => Buffer.from(r, "binary").toString("base64") : Me, $e = z ? (r) => Buffer.from(r).toString("base64") : (r) => {
  let e = [];
  for (let t = 0, n = r.length; t < n; t += 4096)
    e.push(w.apply(null, r.subarray(t, t + 4096)));
  return me(e.join(""));
}, Ge = (r) => {
  if (r.length < 2) {
    var e = r.charCodeAt(0);
    return e < 128 ? r : e < 2048 ? w(192 | e >>> 6) + w(128 | e & 63) : w(224 | e >>> 12 & 15) + w(128 | e >>> 6 & 63) + w(128 | e & 63);
  } else {
    var e = 65536 + (r.charCodeAt(0) - 55296) * 1024 + (r.charCodeAt(1) - 56320);
    return w(240 | e >>> 18 & 7) + w(128 | e >>> 12 & 63) + w(128 | e >>> 6 & 63) + w(128 | e & 63);
  }
}, je = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, Be = (r) => r.replace(je, Ge), ie = z ? (r) => Buffer.from(r, "utf8").toString("base64") : oe ? (r) => $e(oe.encode(r)) : (r) => me(Be(r)), j = (r, e = !1) => e ? xe(ie(r)) : ie(r);
class f {
  /**
   * Info log
   * @param params
   */
  static info(e) {
    f.log({
      ...e,
      level: "INFO"
    });
  }
  /**
   * Warn log
   * @param params
   */
  static warn(e) {
    f.log({
      ...e,
      level: "WARN"
    });
  }
  /**
   * Error log
   * @param params
   */
  static error(e) {
    f.log({
      ...e,
      level: "ERROR"
    });
  }
  /**
   * Debug log
   * @param params
   */
  static debug(e) {
    f.log({
      ...e,
      level: "DEBUG"
    });
  }
  /**
   * Dispatch message to the server
   * @param params
   * @private
   */
  static log(e) {
    try {
      const t = {
        level: e.level.toUpperCase(),
        dt: (/* @__PURE__ */ new Date()).toISOString(),
        // must be in ISO 8601
        code: e.code,
        encoded: !0
      };
      e.source ?? !1 ? t.message = j(`${e.source}: ${e.message}`) : t.message = j(e.message), e.context && (t.context = j(JSON.stringify(e.context))), e.code || (t.code = 1e3), e.level || (t.level = "INFO"), C("/checkout/journal", 204, null, t, { checkSuccessParam: !1 });
    } catch (t) {
      console.error("Log error", t);
    }
  }
}
let ae = class O {
  /**
   * Redirect to url by GET method
   * @param url
   * @param redirectLevel
   */
  static redirectGet(e, t = null) {
    if (!e || typeof e != "string")
      throw new g("Cannot GET redirect to invalid URL address.", { url: e, redirectLevel: t });
    const n = O.getRedirectWindow(t);
    try {
      n.location.href = e;
    } catch {
      window.location.href = e;
    }
  }
  /**
   * Redirect to url by POST method (with form submitting)
   */
  static redirectPost(e, t, n, o = null) {
    if (!e || typeof e != "string")
      throw new g("Cannot POST redirect to invalid URL address.", { url: e, fields: t, enctype: n, redirectLevel: o });
    const i = document.createElement("form");
    i.action = e, i.method = "POST", i.enctype = "multipart/form-data", i.target = O.getFormEscapeTarget(o), document.body.append(i);
    for (const s in t) {
      const l = document.createElement("input");
      l.type = "hidden", l.name = s, l.name = s, l.value = t[s], i.append(l);
    }
    n && (i.enctype = n, i.encoding = n), i.submit();
  }
  /**
   * Redirect to url by submitting form with iframe escape
   */
  static redirectFormPost(e, t = null) {
    if (!e || typeof e != "string")
      throw new g("Cannot redirect to invalid form.", { formDef: e, redirectLevel: t });
    const n = document.createElement("div");
    n.innerHTML = e;
    const o = n.firstChild;
    if (o && o instanceof HTMLFormElement)
      o.target = O.getFormEscapeTarget(t ?? 99), document.body.append(o), o.submit();
    else
      throw new g("Cannot get form from virtual DIV.", { formDef: e, redirectLevel: t });
  }
  /**
   * Vrátí cílový target pro přesměrování
   * @param redirectLevel
   * @private
   */
  static getFormEscapeTarget(e) {
    return e && e <= 0 || window.self === window.top ? "_self" : e && e === 1 ? "_parent" : "_top";
  }
  /**
   * Get Window object for redirection
   * @param redirectLevel
   * @private
   */
  static getRedirectWindow(e) {
    let t = window;
    if (e != null) {
      if (e < 0 && t != null && t.top)
        t = t.top;
      else if (e > 0)
        for (let n = 0; n < e; n++)
          t != null && t.parent && (t = t.parent);
    }
    return t;
  }
};
function L(r, e = [], t = 5) {
  let n = typeof r;
  if (r === null && (n = "null"), r instanceof Date)
    return r;
  switch (n) {
    case "object":
      if (t <= 0)
        return "==deeper==";
      if ("data" in r && "status" in r && "statusText" in r && "headers" in r && "config" in r)
        return K(r);
      if (r instanceof Error) {
        const i = {
          name: r.name,
          message: r.message,
          stack: r.stack,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          cause: r.cause
        };
        return r instanceof g && (i.context = r.context), L(i, e, 3);
      }
      const o = {};
      for (const i in r) {
        const s = ["client", "session", "token", "password", "parentElement", "parentNode", "children", "childNodes", "innerHTML", "outerHTML", "innerText", "ownerDocument", "offsetParent", "ownerElement", "googlepayClient", "window", "self", "document", "top", "parent", "state", "frames", "navigator", "doctype", "documentElement", "body", "head", "defaultView", "scripts", "scrollingElement", "firstElementChild", "lastElementChild", "activeElement", "styleSheets", "adoptedStyleSheets", "firstChild"];
        if (!e.includes(i)) {
          if (s.includes(i)) {
            o[i] = "==skip==";
            continue;
          }
          o[i] = L(r[i], e, t - 1);
        }
      }
      return o;
    case "function":
    case "func":
      return "func";
  }
  return r;
}
function K(r) {
  var e, t, n, o, i, s, l;
  try {
    return {
      request: {
        base: (e = r.config) == null ? void 0 : e.baseURL,
        // url na kterou vedl request
        url: (t = r.config) == null ? void 0 : t.url,
        // url na kterou vedl request
        data: (n = r.config) == null ? void 0 : n.data,
        // POST data requestu
        params: (o = r.config) == null ? void 0 : o.params,
        // query parametry requestu
        method: (i = r.config) == null ? void 0 : i.method,
        // http metoda (GET, POST, ...)
        timeout: (s = r.config) == null ? void 0 : s.timeout,
        // timeout requestu
        headers: (l = r.config) == null ? void 0 : l.headers
        //hlavičky requestu
      },
      response: {
        status: r.status,
        // návratový status kód našeho API
        data: r.data,
        // response body (json/html)
        headers: r.headers
        // response headers
      }
    };
  } catch (c) {
    return "Axios parse error: " + (c == null ? void 0 : c.message);
  }
}
const Fe = {
  clearedDeepCopy: L,
  convertAxios: K
}, _ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearedDeepCopy: L,
  convertAxios: K,
  default: Fe
}, Symbol.toStringTag, { value: "Module" }));
async function Z(r) {
  return new Promise((e, t) => {
    try {
      if (document.getElementById(r.id))
        r.foundValidator ? typeof r.foundValidator != "function" ? (console.warn("FoundValidator is not a function"), e(!1)) : r.foundValidator() === !0 ? e(!0) : t("Script injected to the DOM but not loaded.") : e(!1);
      else {
        let n = null;
        if (r.elementType === "script")
          n = document.createElement("script"), n.src = r.link, n.async = r.async ?? !1, n.defer = r.defer ?? !1;
        else if (r.elementType === "link")
          n = document.createElement("link"), n.href = r.link, n.rel = r.rel, n.as = r.as;
        else
          throw new CgError("Invalid elementType: " + r.elementType);
        n.id = r.id, n.addEventListener("load", () => {
          typeof r.foundValidator == "function" && r.foundValidator() === !0 ? e(!0) : e(!1);
        }), n.addEventListener("error", (o) => {
          t(o);
        }), document.head.append(n);
      }
    } catch (n) {
      t(n);
    }
  });
}
const He = "1.0.5";
function Ve(r, e = null) {
  return V("/checkout/data/load", 200, {
    transId: e,
    checkoutId: r
  });
}
function We(r, e) {
  return V("/checkout/data/payment", 200, {
    transId: e,
    checkoutId: r
  });
}
const se = ["cs", "de", "en", "es", "fr", "hr", "hu", "it", "no", "pl", "ro", "si", "sl", "sk", "sv"], ze = ["PAID", "AUTHORIZED", "PENDING", "CANCELLED"], I = {
  style: ["black", "white", "white-outline"],
  type: ["plain", "add-money", "book", "buy", "check-out", "continue", "contribute", "donate", "order", "pay", "reload", "rent", "set-up", "subscribe", "support", "tip", "top-up"],
  locale: ["en-US", "ar-AB", "ca-ES", "zh-CN", "zh-HK", "zh-TW", "hr-HR", "cs-CZ", "da-DK", "de-DE", "nl-NL", "en-AU", "en-GB", "fi-FI", "fr-CA", "fr-FR", "de-DE", "el-GR", "he-IL", "hi-IN", "hu-HU", "id-ID", "it-IT", "ja-JP", "ko-KR", "ms-MY", "nb-NO", "pl-PL", "pt-BR", "pt-PT", "ro-RO", "ru-RU", "sk-SK", "es-MX", "es-ES", "sv-SE", "th-TH", "tr-TR", "uk-UA", "vi-VN"]
}, k = {
  style: ["black", "white"],
  type: ["book", "buy", "checkout", "donate", "order", "pay", "plain", "subscribe"],
  locale: ["ar", "bg", "ca", "zh", "hr", "cs", "da", "nl", "en", "et", "fi", "fr", "de", "el", "id", "it", "ja", "ko", "ms", "no", "pl", "pt", "ru", "sr", "sk", "sl", "es", "sv", "th", "tr", "uk"]
}, ve = {
  // a = Apple | g = Google
  cs: { a: "cs-CZ", g: "cs" },
  de: { a: "de-DE", g: "de" },
  en: { a: "en-GB", g: "en" },
  es: { a: "es-ES", g: "es" },
  fr: { a: "fr-FR", g: "fr" },
  hr: { a: "hr-HR", g: "hr" },
  hu: { a: "hu-HU", g: "en" },
  // Google Pay does not support Hungarian
  it: { a: "it-IT", g: "it" },
  no: { a: "nb-NO", g: "no" },
  pl: { a: "pl-PL", g: "pl" },
  ro: { a: "ro-RO", g: "en" },
  // Google Pay does not support Romanian
  si: { a: "en-GB", g: "sl" },
  // fallback from our lang name error / Apple Pay does not support Slovenian
  sl: { a: "en-GB", g: "sl" },
  // Apple Pay does not support Slovenian
  sk: { a: "sk-SK", g: "sk" },
  sv: { a: "sv-SE", g: "sv" }
}, Ke = /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/i, Ze = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i, Y = "in|px|pt|pc|em|ex|ch|rem|vw|vh|vmin|vmax|%", fe = new RegExp(`^\\d+(${Y})$`, "i");
let u = class extends Error {
  constructor(t, n = null, o = null) {
    super(t);
    v(this, "context");
    v(this, "prev");
    this.name = "CgError", this.context = n ?? null, this.prev = o ?? null;
  }
};
const Ye = (r) => (Re("data-v-d20854a4"), r = r(), Te(), r), Xe = /* @__PURE__ */ Ye(() => /* @__PURE__ */ H("span", { class: "loader" }, null, -1)), Je = [
  Xe
], Qe = /* @__PURE__ */ $({
  __name: "Loader",
  props: {
    // barva animace
    type: {
      type: String,
      validator: (r) => ["black", "white"].includes(r),
      default: "black"
    }
  },
  setup(r) {
    const e = r;
    return (t, n) => (b(), R("div", {
      class: ce(["loader-box", e.type])
    }, Je, 2));
  }
}), X = (r, e) => {
  const t = r.__vccOpts || r;
  for (const [n, o] of e)
    t[n] = o;
  return t;
}, ge = /* @__PURE__ */ X(Qe, [["__scopeId", "data-v-d20854a4"]]);
function et() {
  var r;
  let e = !1;
  try {
    e = (r = window.navigator) == null ? void 0 : r.javaEnabled();
  } catch {
  }
  return {
    language: window.navigator.language,
    colorDepth: window.screen.colorDepth,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width,
    timezone: (/* @__PURE__ */ new Date()).getTimezoneOffset(),
    javaEnabled: e,
    javascriptEnabled: !0
  };
}
function tt(r, e, t = !1) {
  return typeof r == "number" && r >= e ? t ? Math.floor(r) >= e ? Math.floor(r) : e : r : e;
}
function we(r) {
  C("/checkout/provider/payment-init", 200, null, {
    transId: r.transactionId,
    checkoutId: r.checkoutId,
    payload: r.token,
    service: r.provider + "_" + r.service,
    isInEshop: r.isInEshop ?? !0
  }).then((e) => {
    J((e == null ? void 0 : e.status) ?? "PENDING", (e == null ? void 0 : e.statusPP) ?? "PENDING", r) || (e != null && e.browserInit && ot(e.browserInit), e != null && e.platbaPlatcePk ? rt({
      ...r,
      platbaPlatcePk: e == null ? void 0 : e.platbaPlatcePk
    }) : D(r, "Parameter platbaPlatcePk is missing.", "payment-init", e));
  }).catch((e) => {
    D(r, "Unexpected error during payment initialization.", "payment-init", e);
  });
}
function rt(r) {
  C("/checkout/provider/payment-process", 200, null, {
    transId: r.transactionId,
    checkoutId: r.checkoutId,
    browserInfo: JSON.stringify(et()),
    browserInfoEncoded: !1,
    platbaPlatcePk: r.platbaPlatcePk,
    payload: r.token,
    service: r.provider + "_" + r.service
  }).then((e) => {
    J((e == null ? void 0 : e.status) ?? "UNKNOWN", (e == null ? void 0 : e.statusPP) ?? "UNKNOWN", r) || be(e, r) || setTimeout(() => {
      Pe(r);
    }, 2e3);
  }).catch((e) => {
    D(r, "Unexpected error during payment process.", "payment-process", e);
  });
}
function Pe(r) {
  C("/checkout/provider/payment-status", 200, null, {
    transId: r.transactionId,
    checkoutId: r.checkoutId,
    platbaPlatcePk: r.platbaPlatcePk,
    service: r.provider + "_" + r.service
  }).then((e) => {
    J((e == null ? void 0 : e.status) ?? "UNKNOWN", (e == null ? void 0 : e.statusPP) ?? "UNKNOWN", r) || be(e, r) || nt(e, r);
  }).catch((e) => {
    D(r, "Unexpected error during payment status.", "payment-status", e);
  });
}
function nt(r, e) {
  if (e.canContinue()) {
    if (r.retry) {
      const t = tt(r.retry, 2e3, !0);
      setTimeout(() => {
        e.canContinue() && Pe(e);
      }, t);
      return;
    }
    D(e, `Invalid payment status '${r == null ? void 0 : r.statusPP}', with no status retry instructions.`, "payment-status-resolver", r);
  }
}
function J(r, e, t) {
  if (["PAID", "AUTHORIZED"].includes(r) || ["PAID", "AUTHORIZED"].includes(e))
    return T(t, !0), t.emits("onPaid", {
      // service will be added automatically
      transactionId: t.transactionId,
      price: t.price,
      currency: t.currency,
      status: r
    }), !0;
  if (r === "CANCELLED" || e === "CANCELLED") {
    t.disableEmitOnPending(), T(t, !1);
    const n = {
      // service will be added automatically
      scope: "payment-status",
      detail: {
        status: r,
        statusPP: e
      },
      params: _.clearedDeepCopy(t)
    };
    return r === "CANCELLED" ? (n.message = "Payment has been cancelled.", t.emits("onCancelled", n)) : (t.showButton(), n.message = "Sub payment has been cancelled.", t.emits("onPending", n)), !0;
  }
  return !1;
}
function be(r, e) {
  return "3dschallenge" in r && (r["3dschallenge"] ?? !1) === !0 && r != null && r.form ? (T(e, !0), ae.redirectFormPost(r == null ? void 0 : r.form, (r == null ? void 0 : r.redirectLevel) ?? 99), !0) : "browserChallenge" in r && r.browserChallenge ? (T(e, !0), ae.redirectGet(r.browserChallenge), !0) : !1;
}
function T(r, e) {
  try {
    if (r != null && r.session)
      window != null && window.ApplePaySession && r.service === "APPLEPAY" && "completePayment" in r.session && (e ? r.session.completePayment(window.ApplePaySession.STATUS_SUCCESS) : r.session.completePayment(window.ApplePaySession.STATUS_FAILURE));
    else
      throw new g("Session is not defined.");
  } catch (t) {
    f.error({
      message: `Error during closeUI with status '${e ? "TRUE" : "FALSE"}'.`,
      code: 666,
      source: "close-ui",
      context: {
        error: t
      }
    });
  }
}
function ot(r) {
  try {
    const e = document.getElementById("cg-browser-init");
    e && e.remove();
    const t = document.createElement("iframe");
    return t.src = r, t.id = "cg-browser-init", t.style.position = "fixed", t.style.top = "-1000px", t.style.left = "-1000px", t.style.width = "1px", t.style.height = "1px", document.body.appendChild(t), !0;
  } catch (e) {
    return f.error({ message: "Error in createInlineIframe", source: "browser-init-iframe", context: e }), !1;
  }
}
function D(r, e, t, n) {
  try {
    r.disableEmitOnPending(), T(r, !1), r.showButton(), r.emits("onError", {
      message: e,
      scope: t,
      detail: _.clearedDeepCopy(r),
      params: _.clearedDeepCopy(n)
    });
  } catch (o) {
    f.error({
      message: "Error during emitError",
      code: 666,
      source: "emit-error",
      context: {
        message: e,
        scope: t,
        error: _.clearedDeepCopy(o),
        payload: _.clearedDeepCopy(r),
        detail: _.clearedDeepCopy(n)
      }
    }), r.emits("onError", {
      message: "Unknown error during emitError.",
      scope: "emit-error",
      error: o
    });
  }
}
function it(r) {
  if (!(window != null && window.ApplePaySession)) {
    r.emits("onError", {
      message: "Apple Pay is not available on this device.",
      scope: "run-apple-pay"
    }), alert("We're very sorry, but Apple Pay is not available on this device. Try another payment method.");
    return;
  }
  const e = {
    canContinue: !0
  }, t = at(r.currency, r.country, r.shop, r.price), n = new window.ApplePaySession(4, t);
  n.onvalidatemerchant = () => {
    st(
      /*event,*/
      n,
      r,
      e
    );
  }, n.onpaymentmethodselected = () => {
    lt(
      /*event,*/
      n,
      r,
      e
    );
  }, n.onpaymentauthorized = (o) => {
    ct(o, n, r, e);
  }, n.oncancel = (o) => {
    e != null && e.canContinue && (e.canContinue = !1, r.showButton(), r.emits("onPending", {
      message: "Sub payment has been cancelled.",
      scope: "ui-closed",
      // @ts-ignore - Error in definition, but it is there
      detail: o == null ? void 0 : o.sessionError
    }));
  }, n.begin();
}
function at(r, e, t, n) {
  return {
    currencyCode: r,
    countryCode: e,
    total: {
      label: t,
      amount: Number(n).toFixed(2)
    },
    supportedNetworks: [
      "visa",
      "masterCard",
      "maestro",
      "vPay"
      /*, 'jcb'*/
    ],
    merchantCapabilities: ["supports3DS", "supportsCredit", "supportsDebit"]
  };
}
function st(r, e, t) {
  C("/checkout/provider/payment-session", 200, null, {
    transId: e.transactionId,
    checkoutId: e.checkoutId,
    service: e.provider + "_APPLEPAY",
    displayName: e.shop,
    initiativeContext: location.hostname ?? ""
    // eshop hostname (https://www.eshop.cz/checkout => www.eshop.cz)
  }).then((n) => n != null && n.session ? (r.completeMerchantValidation(n == null ? void 0 : n.session), Promise.resolve()) : Promise.reject({
    message: "Session is missing",
    data: n
  })).catch((n) => {
    t.canContinue = !1, r.completeMerchantValidation({}), e.showButton(), e.emits("onError", {
      message: "Invalid Apple Pay merchant session. Is Merchant correctly registered in Apple?",
      scope: "invalid-merchant-session",
      error: n
    });
  });
}
function lt(r, e, t) {
  try {
    const n = { type: "final", label: e.shop, amount: Number(e.price).toFixed(2) }, o = Array();
    r.completePaymentMethodSelection(n, o);
  } catch (n) {
    t.canContinue = !1, r.abort(), e.showButton(), e.emits("onError", {
      message: "Invalid Apple Pay method selected.",
      scope: "invalid-method-selected",
      error: n
    });
  }
}
function ct(r, e, t, n) {
  const o = btoa(JSON.stringify(r.payment.token.paymentData)), i = {
    ...t,
    // add more params to object
    token: o,
    session: e,
    service: "APPLEPAY",
    canContinue: () => n.canContinue,
    disableEmitOnPending: () => {
      n.canContinue = !1;
    }
  };
  we(i);
}
function Q(r = {}, e) {
  const t = /^[A-Za-z0-9_-]{1,50}$/, n = /^[0-9](|[0-9])(|[0-9])(|[0-9])(in|px|pt|pc|em|ex|ch|rem|vw|vh|vmin|vmax|%)$/, o = {
    // = STATIC VALUES ================================================================
    // payment provider ID (CSOB, COMGATE)
    provider: {
      type: String,
      required: !0,
      validator: (i) => t.test(i)
    },
    // non-iterative ID for shop connection
    checkoutId: {
      type: String,
      required: !0,
      validator: (i) => t.test(i)
    },
    // Shop connection ID
    merchantId: {
      type: String,
      required: r == null ? void 0 : r.merchantIdRequired,
      validator: (i) => t.test(i)
    },
    // ID from provider (itcardId: for comgate, MIPS for csob)
    mid: {
      type: String,
      required: r == null ? void 0 : r.midRequired,
      validator: (i) => t.test(i)
    },
    // shop name
    shop: {
      type: String,
      required: !0,
      validator: (i) => /^.{1,100}$/.test(i),
      default: window.location.hostname
    },
    // button style by Apple specification
    buttonStyle: {
      type: String,
      validator: (i) => {
        var s;
        return (s = r == null ? void 0 : r.buttonStyle) == null ? void 0 : s.includes(i);
      },
      default: "black"
    },
    // button type by Apple specification
    buttonType: {
      type: String,
      validator: (i) => {
        var s;
        return (s = r == null ? void 0 : r.buttonType) == null ? void 0 : s.includes(i);
      },
      default: "check-out"
    },
    // button width
    buttonWidth: {
      type: String,
      validator: (i) => n.test(i),
      default: "100%"
    },
    // button height
    buttonHeight: {
      type: String,
      validator: (i) => n.test(i),
      default: "100%"
    },
    // = REACTIVE VALUES ===============================================================
    // transaction ID
    transactionId: {
      type: String,
      required: !1,
      validator: (i) => t.test(i),
      default: null
    },
    // button locale
    locale: {
      type: String,
      validator: (i) => {
        var s;
        return (s = r == null ? void 0 : r.locale) == null ? void 0 : s.includes(i);
      }
    },
    // The total amount of the payment
    price: {
      type: Number,
      validator: (i) => i >= 0 && i < 1e7,
      default: null
    },
    // currency code (USD, CZK, ...)
    currency: {
      type: String,
      validator: (i) => {
        var s;
        return (s = r == null ? void 0 : r.currency) == null ? void 0 : s.includes(i);
      },
      default: null
    },
    // country in which the payment is made (currently only CZ)
    country: {
      type: String,
      validator: (i) => {
        var s;
        return (s = r == null ? void 0 : r.country) == null ? void 0 : s.includes(i);
      },
      default: "CZ"
    },
    // flag for payer payment created by GP and AP
    isInEshop: {
      type: Boolean,
      default: !0
    }
  };
  if (e) {
    for (const s in o)
      "type" in o[s] && delete o[s].type, "validator" in o[s] && delete o[s].validator;
    const i = {
      type: Function,
      required: !1
    };
    o.onPaid = i, o.onPending = i, o.onCancelled = i, o.onClick = i, o.onError = i, o.chooseService = {
      type: String,
      required: !0,
      validator: (s) => ["applepay", "googlepay"].includes(s)
    };
  }
  return o;
}
const ut = ["lang"], dt = /* @__PURE__ */ $({
  __name: "ApplePayButton",
  props: Q(
    {
      merchantIdRequired: !0,
      midRequired: !0,
      // prettier-ignore
      locale: ["en-US", "ar-AB", "ca-ES", "zh-CN", "zh-HK", "zh-TW", "hr-HR", "cs-CZ", "da-DK", "de-DE", "nl-NL", "en-AU", "en-GB", "fi-FI", "fr-CA", "fr-FR", "de-DE", "el-GR", "he-IL", "hi-IN", "hu-HU", "id-ID", "it-IT", "ja-JP", "ko-KR", "ms-MY", "nb-NO", "pl-PL", "pt-BR", "pt-PT", "ro-RO", "ru-RU", "sk-SK", "es-MX", "es-ES", "sv-SE", "th-TH", "tr-TR", "uk-UA", "vi-VN"],
      currency: ["CZK", "EUR", "PLN", "HUF", "USD", "GBP", "RON", "NOK", "SEK"],
      country: ["CZ"],
      buttonStyle: ["black", "white", "white-outline"],
      // prettier-ignore
      buttonType: ["plain", "add-money", "book", "buy", "check-out", "continue", "contribute", "donate", "order", "pay", "reload", "rent", "set-up", "subscribe", "support", "tip", "top-up"]
    },
    !1
  ),
  emits: ["onPaid", "onPending", "onCancelled", "onClick", "onError"],
  setup(r, { emit: e }) {
    const t = r, n = A(!1), o = A(!!(window != null && window.ApplePaySession));
    async function i() {
      if (n.value)
        return;
      c();
      let m = !1;
      if (await new Promise((h, d) => {
        e("onClick", { resolve: h, reject: d });
      }).catch(() => {
        m = !0;
      }), m) {
        l();
        return;
      }
      if (!t.transactionId || !t.price || !t.currency || !t.country || !t.provider || !t.checkoutId || !t.merchantId || !t.mid || !t.shop) {
        e("onError", {
          message: "Missing any Apple Pay init data.",
          scope: "after-ap-clicked-validation",
          detail: {
            transactionId: t.transactionId,
            price: t.price,
            currency: t.currency,
            country: t.country,
            provider: t.provider,
            checkoutId: t.checkoutId,
            merchantId: t.merchantId,
            mid: t.mid,
            shop: t.shop
          }
        }), l();
        return;
      }
      try {
        it({
          transactionId: t.transactionId,
          price: t.price,
          currency: t.currency,
          country: t.country,
          provider: t.provider,
          checkoutId: t.checkoutId,
          merchantId: t.merchantId,
          // naše propojení obchodu
          mid: t.mid,
          // id od providera (CSOB: opět propojení obchodu, COMGATE G-mid)
          shop: t.shop,
          isInEshop: t.isInEshop,
          emits: e,
          showButton: l
        });
      } catch (h) {
        l(), e("onError", {
          message: "Unexpected error during Apple Pay.",
          scope: "ap-running",
          error: h
        });
      }
    }
    const s = Ce(() => t.buttonStyle + " " + t.buttonType + " " + (n.value ? "running" : ""));
    function l() {
      n.value = !1;
    }
    function c() {
      n.value = !0;
    }
    return (m, h) => (b(), R("div", {
      class: "cg-ap-container",
      style: le({ width: t.buttonWidth, height: t.buttonHeight })
    }, [
      o.value ? q((b(), R("div", {
        key: 0,
        class: ce(["cg-ap-button", s.value]),
        lang: t.locale,
        onClick: i
      }, null, 10, ut)), [
        [N, !n.value]
      ]) : Ee("", !0),
      q(ue(ge, {
        class: "cg-ap-loader",
        type: (t == null ? void 0 : t.buttonStyle) === "black" ? "black" : "white",
        style: { width: "inherit", height: "inherit" }
      }, null, 8, ["type"]), [
        [N, n.value]
      ])
    ], 4));
  }
}), ht = /* @__PURE__ */ X(dt, [["__scopeId", "data-v-c5d234b0"]]), pt = 2, yt = 0;
function mt(r) {
  if (!(r != null && r.client)) {
    r.emits("onError", {
      message: "Google Pay is not available on this device.",
      scope: "run-google-pay"
    }), alert("We're very sorry, but Apple Pay is not available on this device. Try another payment method.");
    return;
  }
  const e = vt(r.provider, r.mid, r.shop, r.price, r.currency), t = new google.payments.api.PaymentsClient({ environment: "PRODUCTION" });
  let n = !0;
  t.loadPaymentData(e).then((o) => {
    const i = o.paymentMethodData.tokenizationData.token, s = {
      ...r,
      // add more params to object
      session: t,
      token: btoa(i),
      service: "GOOGLEPAY",
      canContinue: () => n,
      disableEmitOnPending: () => {
        n = !1;
      }
    };
    we(s);
  }).catch((o) => {
    var i, s;
    if ((o == null ? void 0 : o.statusCode) === "CANCELED" && (o == null ? void 0 : o.message) === void 0 || (i = o == null ? void 0 : o.message) != null && i.includes("User closed the Payment Request UI")) {
      r.emits("onPending", {
        message: "User closed Google Pay Payment UI.",
        scope: "user-closed-ui",
        detail: o
      }), r.showButton();
      return;
    }
    if ((s = o == null ? void 0 : o.message) != null && s.includes("Another PaymentRequest UI is already showing")) {
      r.emits("onPending", {
        message: "Another Google Pay PaymentRequest UI is already showing.",
        scope: "gp-ui-already-showing",
        detail: o
      }), r.showButton();
      return;
    }
    r.emits("onPending", {
      message: "Unknown Google Pay error.",
      scope: "unknown-gp-error",
      detail: o
    }), r.showButton();
  });
}
function ee(r, e) {
  return [
    {
      type: "CARD",
      parameters: {
        allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        allowedCardNetworks: [
          /*'AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MIR',*/
          "MASTERCARD",
          "VISA"
        ]
      },
      tokenizationSpecification: {
        type: "PAYMENT_GATEWAY",
        parameters: {
          gateway: ft(r),
          gatewayMerchantId: e || ""
          // CSOB MIPS merchanta /  u ITCARD jen naše propojení obchodu
        }
      }
    }
  ];
}
function vt(r, e, t, n, o) {
  return {
    apiVersion: pt,
    apiVersionMinor: yt,
    allowedPaymentMethods: ee(r, e),
    // IsReadyToPayRequest
    merchantInfo: {
      merchantId: "BCR2DN4TYDF5PZAV",
      merchantName: t
      // 'Example Merchant' - jedná se jen o string, který se zobrazí v UI
    },
    transactionInfo: {
      totalPriceStatus: "FINAL",
      // částka se již nebude měnit
      totalPrice: Number(n).toFixed(2),
      // '1.00'
      currencyCode: o,
      // USD, CZK, ...
      countryCode: "CZ"
    }
  };
}
function B(r, e) {
  return {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: ee(r, e)
  };
}
function ft(r) {
  const e = ["j", "u", "!", "d", "b", "s", "n", "d", "b", "m", "r", "p", "q", "f", "s", "t", "j", "d"], t = ["r", "c", "b", "a", "b", "i", "q", "d", "v", "r", "o", "e", "a", "l", "d", "g", "y"], n = (t[1] + e[5] + t[10] + e[4]).toUpperCase(), o = (t[5] + e[15] + t[1] + t[3] + t[0] + e[3]).toUpperCase(), i = (t[1] + t[10] + e[9] + t[15] + t[3] + e[15] + t[11]).toUpperCase();
  switch (r) {
    case n:
      return n.toLowerCase();
    case o:
    case i:
      return t[5] + e[15] + t[1] + t[3] + t[0] + e[3] + e[11] + t[3] + t[16] + e[9] + t[11] + e[6] + e[15] + e[5] + t[11] + e[10] + t[8] + t[5] + t[1] + t[11];
    default:
      return "unknown";
  }
}
async function gt() {
  return Z({
    id: "cg-attach-gpay",
    elementType: "script",
    link: "https://pay.google.com/gp/p/js/pay.js",
    async: !0,
    foundValidator: () => !!(window != null && window.google)
  });
}
const wt = /* @__PURE__ */ $({
  __name: "GooglePayButton",
  props: Q(
    {
      merchantIdRequired: !0,
      midRequired: !0,
      // prettier-ignore
      locale: ["ar", "bg", "ca", "zh", "hr", "cs", "da", "nl", "en", "et", "fi", "fr", "de", "el", "id", "it", "ja", "ko", "ms", "no", "pl", "pt", "ru", "sr", "sk", "sl", "es", "sv", "th", "tr", "uk"],
      currency: ["CZK", "EUR", "PLN", "HUF", "USD", "GBP", "RON", "NOK", "SEK"],
      country: ["CZ"],
      buttonStyle: ["black", "white"],
      buttonType: ["book", "buy", "checkout", "donate", "order", "pay", "plain", "subscribe"]
    },
    !1
  ),
  emits: ["onPaid", "onPending", "onCancelled", "onClick", "onError"],
  setup(r, { emit: e }) {
    const t = r, n = A(null), o = A(!1), i = A(null);
    async function s() {
      if (o.value)
        return;
      m();
      let h = !1;
      if (await new Promise((d, P) => {
        e("onClick", { resolve: d, reject: P });
      }).catch(() => {
        h = !0;
      }), h) {
        c();
        return;
      }
      if (!t.transactionId || !t.price || !t.currency || !t.country || !t.provider || !t.checkoutId || !t.merchantId || !t.mid || !t.shop) {
        e("onError", {
          message: "Missing any Google Pay init data.",
          scope: "after-gp-clicked-validation",
          detail: {
            transactionId: t.transactionId,
            price: t.price,
            currency: t.currency,
            country: t.country,
            provider: t.provider,
            checkoutId: t.checkoutId,
            merchantId: t.merchantId,
            mid: t.mid,
            shop: t.shop
          }
        }), c();
        return;
      }
      try {
        mt({
          client: i.value,
          transactionId: t.transactionId,
          price: t.price,
          currency: t.currency,
          country: t.country,
          provider: t.provider,
          checkoutId: t.checkoutId,
          merchantId: t.merchantId,
          // naše propojení obchodu
          mid: t.mid,
          // id od providera (CSOB: MIPS, COMGATE: G-mid)
          shop: t.shop,
          isInEshop: t.isInEshop,
          emits: e,
          showButton: c
        });
      } catch (d) {
        c(), e("onError", {
          message: "Unexpected error during Google Pay.",
          scope: "gp-running",
          error: d
        });
      }
    }
    function l() {
      try {
        if (!n.value) {
          e("onError", {
            message: "Missing Google Pay container.",
            scope: "render-gp-button"
          });
          return;
        }
        gt().then(() => {
          const h = new google.payments.api.PaymentsClient({ environment: "PRODUCTION" });
          i.value = h, h.isReadyToPay(B(t.provider, t.mid)).then((d) => {
            if (d.result) {
              const P = h.createButton({
                buttonColor: t.buttonStyle,
                buttonType: t.buttonType,
                buttonLocale: t.locale,
                buttonSizeMode: "fill",
                allowedPaymentMethods: ee(t.provider, t.mid),
                onClick: s
              });
              n.value ? (n.value.innerHTML = "", n.value.appendChild(P)) : e("onError", {
                message: "Google Pay button cannot be attach. Container not found.",
                scope: "attach-gp-button"
              });
            } else
              e("onError", {
                message: "Google Pay Library cannot create button because payment is not allowed.",
                scope: "gp-library-said-no"
              });
          }).catch((d) => {
            e("onError", {
              message: "Unexpected error during Google Pay isReadyToPay.",
              scope: "gp-is-ready-to-pay-error",
              detail: {
                isReadyToPayRequest: B(t.provider, t.mid)
              },
              error: d
            });
          });
        });
      } catch (h) {
        e("onError", {
          message: "Unexpected error during creating Google Pay Button.",
          scope: "gp-btn-error",
          detail: {
            isReadyToPayRequest: B(t.provider, t.mid)
          },
          error: h
        });
      }
    }
    Se(() => t.locale, (h, d) => {
      d != h && (h ? l() : n.value && (n.value.innerHTML = ""));
    });
    function c() {
      o.value = !1;
    }
    function m() {
      o.value = !0;
    }
    return Ae(() => {
      l();
    }), (h, d) => (b(), R("div", {
      class: "cg-gp-container",
      style: le({ width: t.buttonWidth, height: t.buttonHeight })
    }, [
      q(H("div", {
        class: "cg-gp-button",
        ref_key: "gpButtonContainer",
        ref: n,
        style: { width: "inherit", height: "inherit" }
      }, null, 512), [
        [N, !o.value]
      ]),
      q(ue(ge, {
        class: "cg-gp-loader",
        type: (t == null ? void 0 : t.buttonStyle) === "black" ? "black" : "white",
        style: { width: "inherit", height: "inherit" }
      }, null, 8, ["type"]), [
        [N, o.value]
      ])
    ], 4));
  }
}), Pt = /* @__PURE__ */ X(wt, [["__scopeId", "data-v-20423f28"]]), bt = {
  key: 2,
  class: "error"
}, It = /* @__PURE__ */ H("p", null, "Missing or invalid chooseService prop.", -1), kt = [
  It
], Ie = /* @__PURE__ */ $({
  __name: "CheckoutWrapper",
  props: Q(
    {
      merchantIdRequired: !0,
      midRequired: !0
    },
    !0
  ),
  setup(r) {
    const e = r;
    function t(n, o = void 0) {
      n in e && typeof e[n] == "function" ? (o && typeof o == "object" && (o.service = e == null ? void 0 : e.chooseService), e[n](o)) : o && "resolve" in o && o.resolve();
    }
    return (n, o) => {
      var i, s, l, c, m, h, d, P, U, E;
      return e.chooseService === "applepay" ? (b(), re(ht, {
        key: 0,
        checkoutId: e.checkoutId,
        merchantId: e.merchantId,
        provider: e.provider,
        mid: e.mid,
        shop: e.shop,
        buttonStyle: e.buttonStyle,
        buttonType: e.buttonType,
        buttonWidth: e.buttonWidth,
        buttonHeight: e.buttonHeight,
        transactionId: (i = e.transactionId) == null ? void 0 : i.value,
        locale: (s = e.locale) == null ? void 0 : s.value,
        price: (l = e.price) == null ? void 0 : l.value,
        currency: (c = e.currency) == null ? void 0 : c.value,
        country: (m = e.country) == null ? void 0 : m.value,
        isInEshop: !0,
        onOnPaid: o[0] || (o[0] = (p) => t("onPaid", p)),
        onOnPending: o[1] || (o[1] = (p) => t("onPending", p)),
        onOnCancelled: o[2] || (o[2] = (p) => t("onCancelled", p)),
        onOnClick: o[3] || (o[3] = (p) => t("onClick", p)),
        onOnError: o[4] || (o[4] = (p) => t("onError", p))
      }, null, 8, ["checkoutId", "merchantId", "provider", "mid", "shop", "buttonStyle", "buttonType", "buttonWidth", "buttonHeight", "transactionId", "locale", "price", "currency", "country"])) : e.chooseService === "googlepay" ? (b(), re(Pt, {
        key: 1,
        checkoutId: e.checkoutId,
        merchantId: e.merchantId,
        provider: e.provider,
        mid: e.mid,
        shop: e.shop,
        buttonStyle: e.buttonStyle,
        buttonType: e.buttonType,
        buttonWidth: e.buttonWidth,
        buttonHeight: e.buttonHeight,
        transactionId: (h = e.transactionId) == null ? void 0 : h.value,
        locale: (d = e.locale) == null ? void 0 : d.value,
        price: (P = e.price) == null ? void 0 : P.value,
        currency: (U = e.currency) == null ? void 0 : U.value,
        country: (E = e.country) == null ? void 0 : E.value,
        isInEshop: !0,
        onOnPaid: o[5] || (o[5] = (p) => t("onPaid", p)),
        onOnPending: o[6] || (o[6] = (p) => t("onPending", p)),
        onOnCancelled: o[7] || (o[7] = (p) => t("onCancelled", p)),
        onOnClick: o[8] || (o[8] = (p) => t("onClick", p)),
        onOnError: o[9] || (o[9] = (p) => t("onError", p))
      }, null, 8, ["checkoutId", "merchantId", "provider", "mid", "shop", "buttonStyle", "buttonType", "buttonWidth", "buttonHeight", "transactionId", "locale", "price", "currency", "country"])) : (b(), R("div", bt, kt));
    };
  }
});
function te(r = {}, e = "globalStoreEvent") {
  function t(o) {
    const i = new CustomEvent(e, {
      bubbles: !0,
      cancelable: !0,
      detail: o
    });
    return document.dispatchEvent(i);
  }
  function n(o, i) {
    return {
      get(s, l) {
        return l === "_isProxy" ? !0 : (["object", "array"].includes(Object.prototype.toString.call(s[l]).slice(8, -1).toLowerCase()) && !s[l]._isProxy && (s[l] = new Proxy(s[l], n())), s[l]);
      },
      set(s, l, c) {
        if (s[l] === c)
          return !0;
        const m = s[l];
        return s[l] = c, t({
          prev: m,
          key: l,
          value: c
        }), !0;
      },
      deleteProperty(s, l) {
        const c = s[l];
        return delete s[l], t({
          prev: c,
          key: l,
          value: void 0
        }), !0;
      },
      has(s, l) {
        return l in s;
      }
    };
  }
  return new Proxy(r, n());
}
const a = te(), y = {
  warn: (...r) => {
    a.debug && console.warn("[Checkout DEBUG]", ...r);
  },
  info: (...r) => {
    a.debug && console.info("[Checkout DEBUG]", ...r);
  },
  error: (...r) => {
    a.debug && console.error("[Checkout DEBUG]", ...r);
  },
  useDebugNotice: () => a.debug ? "" : " Use debug for more details."
};
class _t {
  /**
   * Constructor
   * @param checkoutInstance
   */
  constructor(e) {
    v(this, "_id", (Math.random() + Date.now()).toString(32).toUpperCase());
    v(this, "_checkoutRef");
    v(this, "_store");
    v(this, "_app");
    v(this, "_instance");
    v(this, "_isMounted", !1);
    v(this, "_reactiveValues");
    this._checkoutRef = e, this._store = te({}, "applepay-" + this._id);
  }
  /**
   * Get unique Apple Pay instance ID
   */
  getId() {
    return this._id;
  }
  /**
   * Create new instance of Apple Pay
   * @param params
   */
  init(e) {
    var t;
    if (((t = a == null ? void 0 : a._applepay) == null ? void 0 : t.enabled) !== !0)
      throw new g("Apple Pay is not enabled." + y.useDebugNotice());
    if (this._store.style = "black", this._store.type = "pay", this._store.width = "100%", this._store.height = "100%", e != null && e.style && this.persistStyle(e.style), e != null && e.locale)
      if (this.validateLocale(e.locale))
        this._store.locale = e.locale;
      else {
        const n = I.locale.join(",");
        y.warn(`Locale '${e.locale}' is not valid for Apple Pay. Used checkout language. Please use one from: [${n}]`);
      }
    return this._store.locale || this.saveMappedLocale(a.locale), Promise.resolve(this);
  }
  /**
   * Save mapped locale from payment
   * @param locale
   * @private
   */
  saveMappedLocale(e) {
    var n;
    const t = (n = ve[e]) == null ? void 0 : n.a;
    return this.validateLocale(t) ? (this._store.locale = t, !0) : (this._store.locale = "cs-CZ", y.warn(`Locale '${e}' inherited from checkout which has been translated to '${t}' is not valid for Apple Pay.`), !1);
  }
  /**
   * Notify Apple Pay that any value has been changed
   * @param key
   * @param oldValue
   * @param newValue
   */
  refresh(e, t, n) {
    try {
      if (!this._isMounted || !this._reactiveValues)
        return;
      switch (e) {
        case "transactionId":
        case "price":
        case "currency":
        case "country":
          this._reactiveValues[e] = n;
          break;
        case "locale":
          this._store.locale !== n && (this.saveMappedLocale(n), this._reactiveValues.locale = this._store.locale);
          break;
        default:
          throw new g(`Unknown Google Pay property for update '${e}'`, {
            key: e,
            oldValue: t,
            newValue: n
          });
      }
    } catch (o) {
      f.error({ message: "ApplePay refresh error", source: "applepay-refresh", context: o });
    }
  }
  /**
   * Check if Apple Pay is available on this device
   */
  async canMakePayment() {
    var e;
    try {
      if (!((e = a._applepay) != null && e.enabled))
        return {
          result: !1,
          reason: "Apple Pay is not enabled"
        };
      if (a._simpleDirector === "transid" && a._paymentFinal)
        return {
          result: !1,
          reason: "Payment is already paid or cancelled"
        };
      if (!(window != null && window.ApplePaySession))
        return {
          result: !1,
          reason: "Apple Pay is not supported in this browser. Only Safari supports it."
        };
      const t = await ApplePaySession.canMakePayments();
      return {
        result: t,
        reason: t ? "OK" : "Apple Pay said no."
      };
    } catch (t) {
      return f.error({ message: "canMakePayment error", source: "applepay", context: t }), {
        result: !1,
        reason: "Unknown error"
      };
    }
  }
  /**
   * Mount Apple Pay button
   * @param mountPoint
   */
  mount(e) {
    if (!this.canMakePayment())
      return window != null && window.ApplePaySession || y.warn("Apple Pay is not supported in this browser. Only Safari supports it. Use canMakePayment() before calling mount()."), !1;
    const t = document.querySelectorAll(e);
    if (!t || t.length <= 0)
      return y.warn(`Apple Pay mount point '${e}' not found.`), !1;
    t.length > 1 && y.warn(`Found more Apple Pay mount points '${e}'. Using first one.`);
    const n = this.getAppRootProps();
    try {
      return this._app = de(Ie, n), this._instance = this._app.mount(e), this._isMounted = !0, !0;
    } catch (o) {
      f.error({ message: "ApplePay mount error", source: "applepay", context: o }), console.error(o);
    }
    return !1;
  }
  /**
   * Unmount Apple Pay button
   */
  unmount() {
    return this._isMounted && (this._isMounted = !1, this._reactiveValues = void 0, this != null && this._app && "unmount" in this._app) ? (this._app.unmount(), !0) : !1;
  }
  /**
   * Destroy this instance
   */
  destroy() {
    var e;
    (e = this._checkoutRef) == null || e.destroyInstance(this), this._isMounted && this.unmount();
    for (const t in this)
      this[t] = null;
  }
  /**
   * Get reactive & static properties for Apple Pay button
   * @private
   */
  getAppRootProps() {
    var n, o, i, s, l, c, m;
    const e = he({
      // dynamické hodnoty
      transactionId: a.transactionId,
      locale: this._store.locale,
      price: (n = a._payment) == null ? void 0 : n.price,
      currency: (o = a._payment) == null ? void 0 : o.currency,
      country: (i = a._payment) == null ? void 0 : i.country
    });
    this._reactiveValues = e;
    const t = pe(e);
    return {
      // fixní hodnoty
      provider: (s = a._applepay) == null ? void 0 : s.provider,
      checkoutId: a == null ? void 0 : a.checkoutId,
      merchantId: (l = a.merchant) == null ? void 0 : l.toString(),
      mid: (m = (c = a._applepay) == null ? void 0 : c.mid) == null ? void 0 : m.toString(),
      shop: a.shop,
      buttonStyle: this._store.style,
      buttonType: this._store.type,
      buttonWidth: this._store.width,
      buttonHeight: this._store.height,
      // reaktivní hodnoty
      transactionId: t.transactionId,
      locale: t.locale,
      price: t.price,
      currency: t.currency,
      country: t.country,
      // ruční mapování funkcí pro emitování událostí
      onPaid: a.onPaid,
      onPending: a.onPending,
      onCancelled: a.onCancelled,
      onClick: a == null ? void 0 : a.onClick,
      onError: a.onError,
      chooseService: "applepay"
    };
  }
  /**
   * Validate Apple Pay button styles (keep default if item is invalid)
   * @param style
   * @protected
   */
  persistStyle(e) {
    try {
      const t = ["type", "style", "width", "height"];
      for (const n of t)
        if (e[n]) {
          let o = `Invalid Apple Pay button ${n}: '${e[n]}'. Used default: `;
          ["type", "style"].includes(n) ? I[n].includes(e[n]) ? (this._store[n] = e[n], o = void 0) : o += `'${this._store[n]}'. Allowed: [${I[n].join(
            ", "
          )}]` : fe.test(e[n]) ? (this._store[n] = e[n], o = void 0) : o += `'${this._store[n]}' Allowed: /^\\d+(${Y})$/i`, o && y.warn(o);
        }
    } catch (t) {
      f.error({ message: "persistStyle error", source: "applepay", context: t }), y.warn("An unexpected error occurred while validating the custom style. Default button style will be used.", t);
    }
  }
  // /**
  //  * Is currency Valid for Apple Pay
  //  * @param newCurrency
  //  * @private
  //  */
  // private validateCurrency(newCurrency: TCurrency): boolean {
  //     return globalStore?.applepay?.curr?.includes(newCurrency);
  // }
  /**
   * Is transaction completely defined?
   * @private
   */
  // private validateTransactionData(): boolean {
  //     return globalStore.transactionId && globalStore.currency && globalStore.price;
  // }
  /**
   * Is locale valid for Apple Pay
   * @param newLocale
   * @private
   */
  validateLocale(e) {
    var t;
    return (t = I == null ? void 0 : I.locale) == null ? void 0 : t.includes(e);
  }
}
class Ct {
  /**
   * Constructor
   * @param checkoutInstance
   */
  constructor(e) {
    v(this, "_id", (Math.random() + Date.now()).toString(32).toUpperCase());
    v(this, "_checkoutRef");
    v(this, "_store");
    v(this, "_app");
    v(this, "_instance");
    v(this, "_isMounted", !1);
    v(this, "_reactiveValues");
    this._checkoutRef = e, this._store = te({}, "googlepay-" + this._id);
  }
  /**
   * Get unique Google Pay instance ID
   */
  getId() {
    return this._id;
  }
  /**
   * Create new instance of Google Pay
   * @param params
   */
  init(e) {
    var t;
    if (((t = a == null ? void 0 : a._googlepay) == null ? void 0 : t.enabled) !== !0)
      throw new g("Google Pay is not enabled." + y.useDebugNotice());
    if (this._store.style = "black", this._store.type = "pay", this._store.width = "100%", this._store.height = "100%", e != null && e.style && this.persistStyle(e.style), e != null && e.locale)
      if (this.validateLocale(e.locale))
        this._store.locale = e.locale;
      else {
        const n = k.locale.join(",");
        y.warn(`Locale '${e.locale}' is not valid for Google Pay. Used checkout language. Please use one from: [${n}]`);
      }
    return this._store.locale || this.saveMappedLocale(a == null ? void 0 : a.locale), Promise.resolve(this);
  }
  /**
   * Save mapped locale from payment
   * @param locale
   * @private
   */
  saveMappedLocale(e) {
    var n;
    const t = (n = ve[e]) == null ? void 0 : n.g;
    return this.validateLocale(t) ? (this._store.locale = t, !0) : (this._store.locale = "cs", y.warn(`Locale '${e}' inherited from checkout which has been translated to '${t}' is not valid for Google Pay.`), !1);
  }
  /**
   * Notify Google Pay that any value has been changed
   * @param key
   * @param oldValue
   * @param newValue
   */
  refresh(e, t, n) {
    try {
      if (!this._isMounted || !this._reactiveValues)
        return;
      switch (e) {
        case "transactionId":
        case "price":
        case "currency":
        case "country":
          this._reactiveValues[e] = n;
          break;
        case "locale":
          this._store.locale !== n && (this.saveMappedLocale(n), this._reactiveValues.locale = this._store.locale);
          break;
        default:
          throw new g(`Unknown Google Pay property for update '${e}'`, {
            key: e,
            oldValue: t,
            newValue: n
          });
      }
    } catch (o) {
      f.error({ message: "GooglePay refresh error", source: "google-refresh", context: o });
    }
  }
  /**
   * Check if Google Pay is available on this device
   */
  async canMakePayment() {
    var e;
    try {
      if (!((e = a._googlepay) != null && e.enabled))
        return {
          result: !1,
          reason: "Google Pay is not enabled"
        };
      if (a._simpleDirector === "transid" && a._paymentFinal)
        return {
          result: !1,
          reason: "Payment is already paid or cancelled"
        };
      let t = !0;
      const n = await Z({
        id: "cg-attach-gpay",
        elementType: "script",
        link: "https://pay.google.com/gp/p/js/pay.js",
        async: !0,
        foundValidator: () => !!(window != null && window.google)
      }).catch(() => {
        t = !1;
      });
      if (t && n === !0) {
        const i = await new google.payments.api.PaymentsClient({ environment: "PRODUCTION" }).isReadyToPay({
          apiVersion: 2,
          apiVersionMinor: 0,
          allowedPaymentMethods: [
            {
              type: "CARD",
              parameters: { allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"], allowedCardNetworks: ["MASTERCARD", "VISA"] }
            }
          ]
        }).catch(() => {
        });
        return {
          result: (i == null ? void 0 : i.result) === !0,
          reason: (i == null ? void 0 : i.result) === !0 ? "OK" : "Google Pay said no"
        };
      }
      return {
        result: !1,
        reason: "Google Pay is not loaded"
      };
    } catch (t) {
      return f.error({ message: "canMakePayment error", source: "googlepay", context: t }), {
        result: !1,
        reason: "Unknown error"
      };
    }
  }
  /**
   * Mount Google Pay button
   * @param mountPoint
   */
  mount(e) {
    if (!this.canMakePayment())
      return !1;
    const t = document.querySelectorAll(e);
    if (!t || t.length <= 0)
      return y.warn(`Google Pay mount point '${e}' not found.`), !1;
    t.length > 1 && y.warn(`Found more Google Pay mount points '${e}'. Using first one.`);
    const n = this.getAppRootProps();
    try {
      return this._app = de(Ie, n), this._instance = this._app.mount(e), this._isMounted = !0, !0;
    } catch (o) {
      f.error({ message: "GooglePay mount error", source: "googlepay", context: o }), console.error(o);
    }
    return !1;
  }
  /**
   * Unmount Google Pay button
   */
  unmount() {
    return this._isMounted && (this._isMounted = !1, this._reactiveValues = void 0, this != null && this._app && "unmount" in this._app) ? (this._app.unmount(), !0) : !1;
  }
  /**
   * Destroy this instance
   */
  destroy() {
    var e;
    (e = this._checkoutRef) == null || e.destroyInstance(this), this._isMounted && this.unmount();
    for (const t in this)
      this[t] = null;
  }
  /**
   * Get reactive & static properties for Google Pay button
   * @private
   */
  getAppRootProps() {
    var n, o, i, s, l, c, m;
    const e = he({
      // dynamické hodnoty
      transactionId: a.transactionId,
      locale: this._store.locale,
      price: (n = a._payment) == null ? void 0 : n.price,
      currency: (o = a._payment) == null ? void 0 : o.currency,
      country: (i = a._payment) == null ? void 0 : i.country
    });
    this._reactiveValues = e;
    const t = pe(e);
    return {
      // fixní hodnoty
      provider: (s = a._googlepay) == null ? void 0 : s.provider,
      checkoutId: a == null ? void 0 : a.checkoutId,
      merchantId: (l = a.merchant) == null ? void 0 : l.toString(),
      mid: (m = (c = a._googlepay) == null ? void 0 : c.mid) == null ? void 0 : m.toString(),
      shop: a.shop,
      buttonStyle: this._store.style,
      buttonType: this._store.type,
      buttonWidth: this._store.width,
      buttonHeight: this._store.height,
      // reaktivní hodnoty
      transactionId: t.transactionId,
      locale: t.locale,
      price: t.price,
      currency: t.currency,
      country: t.country,
      // ruční mapování funkcí pro emitování událostí
      onPaid: a.onPaid,
      onPending: a.onPending,
      onCancelled: a.onCancelled,
      onClick: a == null ? void 0 : a.onClick,
      onError: a.onError,
      chooseService: "googlepay"
    };
  }
  /**
   * Validate Google Pay button styles (keep default if item is invalid)
   * @param style
   * @protected
   */
  persistStyle(e) {
    try {
      const t = ["type", "style", "width", "height"];
      for (const n of t)
        if (e[n]) {
          let o = `Invalid Google Pay button ${n}: '${e[n]}'. Used default: `;
          ["type", "style"].includes(n) ? k[n].includes(e[n]) ? (this._store[n] = e[n], o = void 0) : o += `'${this._store[n]}'. Allowed: [${k[n].join(", ")}]` : fe.test(e[n]) ? (this._store[n] = e[n], o = void 0) : o += `'${this._store[n]}' Allowed: /^\\d+(${Y})$/i`, o && y.warn(o);
        }
    } catch (t) {
      f.error({ message: "persistStyle error", source: "googlepay", context: t }), y.warn("An unexpected error occurred while validating the custom style. Default button style will be used.", t);
    }
  }
  // /**
  //  * Is currency Valid for Google Pay
  //  * @param newCurrency
  //  * @private
  //  */
  // private validateCurrency(newCurrency: TCurrency): boolean {
  //     return globalStore?.googlepay?.curr?.includes(newCurrency);
  // }
  /**
   * Is transaction completely defined?
   * @private
   */
  // private validateTransactionData(): boolean {
  //     return globalStore.transactionId && globalStore.currency && globalStore.price;
  // }
  /**
   * Is locale valid for Google Pay
   * @param newLocale
   * @private
   */
  validateLocale(e) {
    var t;
    return (t = k == null ? void 0 : k.locale) == null ? void 0 : t.includes(e);
  }
}
const M = class M {
  /**
   * Create new instance of Checkout
   * @param params
   */
  constructor(e) {
    a._instances = [], a._server = {}, a._googlepay = { enabled: !1 }, a._applepay = { enabled: !1 }, a._payment = null, a._paymentFinal = !1, a._invalidateRequestedPaymentId = !1, a._paymentIdCache = null, a.debug = !!(e != null && e.debug);
    const t = this.checkEnvironmentSecurity();
    if (t !== !0 && (y.warn(`Minimal security requirements are not met:
`, t), !a.debug))
      throw new u("Comgate Checkout Library: browser and website does not meet minimum security requirements." + y.useDebugNotice());
    if (e != null && e.mode || (e.mode = "simple"), !["simple", "advanced"].includes(e.mode))
      throw new u(`Invalid mode: '${e.mode}'.`);
    if (a.mode = e.mode, !(e != null && e.checkoutId))
      throw new u("CheckoutId is required");
    if (!Ze.test(e.checkoutId))
      throw new u(`Invalid checkoutId: ${e.checkoutId}`);
    a.checkoutId = e.checkoutId;
    let n = [];
    if (a.mode === "simple")
      if (n = ["onPaid", "onCancelled", "onError"], e != null && e.transactionId && !(e != null && e.onRequirePayment))
        a._simpleDirector = "transid", y.info("Enabled mode: payment at the beginning"), this.testTransactionId(e.transactionId, !0), a._paymentIdCache = e.transactionId;
      else if (!(e != null && e.transactionId) && typeof (e == null ? void 0 : e.onRequirePayment) == "function")
        a._simpleDirector = "handler", y.info("Enabled mode: payment will be created in the future"), n.push("onRequirePayment"), a._invalidateRequestedPaymentId = !0;
      else
        throw new u("You have to provide either transactionId or onRequirePayment. Not both, but at least one.");
    else if (a.mode === "advanced")
      throw n = [], new u("Mode 'advanced' is not currently available. Will be available soon...");
    e != null && e.locale && this.updateLocale(e == null ? void 0 : e.locale);
    const o = ["onRequirePayment", "onPaid", "onCancelled", "onPending", "onClick", "onError"];
    for (const i of o)
      if (e[i]) {
        if (typeof e[i] != "function")
          throw new u(`Checkout init: '${i}' is not a valid function!`);
        i === "onRequirePayment" ? a[i] = e[i] : a[i] = (s) => this.handlerProxy(i, s, e[i]);
      } else {
        if (n.includes(i))
          throw new u(`Checkout init: function '${i}' is required in mode '${a.mode}'!`);
        i === "onClick" && a._simpleDirector === "handler" && (a[i] = (s) => this.handlerProxy(i, s, (l) => {
          l.resolve();
        }));
      }
  }
  /**
   * Initialize instance and return itself
   */
  async init() {
    if (a._simpleDirector === "transid")
      this.testTransactionId(a._paymentIdCache, !0);
    else if (a._paymentIdCache !== null)
      throw new u("Payment Id should be empty during initialization with 'onRequirePayment'.");
    return await Ve(a.checkoutId, a._paymentIdCache).then((e) => {
      var t, n, o, i, s;
      if ((e == null ? void 0 : e.test) === !0 && console.warn("Comgate Checkout: Payment in TEST mode used."), a.locale || this.updateLocale(((t = e == null ? void 0 : e.payment) == null ? void 0 : t.lang) ?? "cs"), se.includes(a.locale) || (y.warn("Invalid locale. Default locale set to 'cs'."), this.updateLocale("cs")), a._simpleDirector === "transid") {
        this.persistPaymentData(e == null ? void 0 : e.payment, a._paymentIdCache);
        const l = a.transactionId;
        a.transactionId = a._paymentIdCache, this.valueUpdate("transactionId", l, a.transactionId), a._paymentIdCache = null;
      }
      if (a._server = e, ((n = e == null ? void 0 : e.applepay) == null ? void 0 : n.enabled) === !0 ? a._applepay = e.applepay : y.warn(`Apple Pay is not enabled.
Detail: ` + ((o = e == null ? void 0 : e.applepay) == null ? void 0 : o.detail)), ((i = e == null ? void 0 : e.googlepay) == null ? void 0 : i.enabled) === !0 ? a._googlepay = e.googlepay : y.warn(`Google Pay is not enabled.
Detail: ` + ((s = e == null ? void 0 : e.applepay) == null ? void 0 : s.detail)), e != null && e.merchant)
        a.merchant = e.merchant;
      else
        throw new u("Merchant data is missing in server response.", e);
      if (e != null && e.shop)
        a.shop = e.shop;
      else
        throw new u("Shop host name is missing in server response.", e);
    }).catch((e) => {
      throw f.error({ message: "Cannot fetch checkout data.", source: "checkout", context: e }), e instanceof u ? e : new u("Comgate Error: Cannot fetch checkout data.", {
        context: e
      });
    }), Promise.resolve(this);
  }
  /**
   * Check website security
   */
  checkEnvironmentSecurity() {
    const e = [];
    return location.protocol !== "https:" && e.push("Website have to be served over HTTPS."), e.length > 0 ? e : !0;
  }
  /**
   * Invalidate data provided by function onRequirePayment
   *   If the onRequirePayment implementation is used, then the onRequirePayment function is called again
   *   when the Google Pay or Apple Pay button is clicked to create a new payment.
   *
   *   PLEASE NEVER CALL THIS FUNCTION UNLESS YOU NEED TO CREATE A NEW PAYMENT.
   *   This function should be called when the amount or currency of an already created payment changes.
   */
  invalidatePayment() {
    return a.mode === "simple" && a._simpleDirector === "transid" && y.warn(
      "Calling the invalidatePayment() method when using an implementation with a payment ID at the beginning will have no effect on future behavior. Please consider unnecessary calling this method."
    ), a._paymentFinal ? !1 : (a._invalidateRequestedPaymentId = !0, !0);
  }
  /**
   * Validate and persist payment data to store
   * @param payment
   * @param transactionId
   * @private
   */
  persistPaymentData(e, t) {
    if (!e)
      throw new u("Payment not found.");
    if (!ze.includes(e == null ? void 0 : e.status))
      throw new u(`Invalid payment status '${e == null ? void 0 : e.status}'.`);
    if (["PAID", "AUTHORIZED", "CANCELLED"].includes(e.status)) {
      a._paymentFinal = !0;
      const n = {
        transactionId: t ?? "unkwnown",
        price: e == null ? void 0 : e.price,
        currency: e == null ? void 0 : e.currency,
        country: e == null ? void 0 : e.country,
        status: e.status
      };
      e.status === "CANCELLED" ? a.onCancelled(n) : a.onPaid(n);
      return;
    }
    if (typeof (e == null ? void 0 : e.price) != "number")
      throw new u("Invalid payment price", { price: e == null ? void 0 : e.price });
    if (e.status === "PENDING") {
      a._payment = e, a._paymentFinal = !1;
      return;
    }
    throw new u(`Invalid payment status: '${e.status}'`, e);
  }
  /**
   * Update UI Locale (cs, de, en, es, fr, hr, hu, it, no, pl, ro, si, sl, sk, sv)
   * @param locale
   */
  updateLocale(e) {
    if (!e || !se.includes(e))
      return y.warn(`Invalid locale: '${e}'. Nothing changed.`), this;
    const t = a.locale;
    return a.locale = e, this.valueUpdate("locale", t, e), this;
  }
  /**
   * Check transactionId format
   * @param transId
   * @param throwException
   * @private
   */
  testTransactionId(e, t = !1) {
    if (!Ke.test(e)) {
      if (t)
        throw new u(`Invalid transactionId format: '${e}'`);
      return !1;
    }
    return !0;
  }
  /**
   * Pre-prepared the server request maker.
   * @param config
   */
  async eshopRequest(e) {
    var t;
    if (!e)
      throw new u("Invalid request configuration.", { config: e });
    if (!((t = e == null ? void 0 : e.url) != null && t.startsWith("https://")))
      throw new u("Invalid request URL. Url have to always start with 'https://'", { url: e == null ? void 0 : e.url });
    if ((e == null ? void 0 : e.method) === "GET") {
      if (!(e != null && e.query))
        throw new u("The request query is required for GET request.", { query: e == null ? void 0 : e.query });
      if (typeof (e == null ? void 0 : e.query) != "object")
        throw new u("The request query should be an object.", { query: e == null ? void 0 : e.query });
      return V(e.url, (e == null ? void 0 : e.validStatus) ?? 200, e.query, { checkSuccessParam: (e == null ? void 0 : e.checkSuccessParam) ?? !1 });
    }
    if ((e == null ? void 0 : e.method) === "POST") {
      if (e != null && e.query && typeof (e == null ? void 0 : e.query) != "object")
        throw new u("The request query should be an object.", { query: e == null ? void 0 : e.query });
      if (!(e != null && e.body))
        throw new u("The request body is required for POST request.", { body: e == null ? void 0 : e.body });
      if (typeof (e == null ? void 0 : e.body) != "object")
        throw new u("The request body should be an object.", { body: e == null ? void 0 : e.body });
      return C(e.url, (e == null ? void 0 : e.validStatus) ?? 200, e.query, e.body, { checkSuccessParam: (e == null ? void 0 : e.checkSuccessParam) ?? !1 });
    }
    throw new u("Invalid request method.", { method: e == null ? void 0 : e.method, allowed: ["GET", "POST"] });
  }
  /**
   * Helper to trigger propagation of changes in all instances of ApplePay, GooglePay, etc.
   * @private
   */
  valueUpdate(e, t, n) {
    try {
      a._instances.forEach((o) => {
        "refresh" in o && o.refresh(e, t, n);
      });
    } catch (o) {
      this.logError("Error during valueUpdate", "value-update", 5468, { updatedKey: e, oldVal: t, newVal: n, error: o });
    }
  }
  /**
   * Check if payment can be made
   */
  async canMakePayment() {
    try {
      return a._paymentFinal !== !1 ? {
        result: !1,
        reason: "Payment is already in final state."
      } : {
        result: !0,
        reason: "OK"
      };
    } catch (e) {
      return this.logError("Error during checkout canMakePayment", "checkout-can-make-payment", 4468, { error: e }), {
        result: !1,
        reason: "Unknown error."
      };
    }
  }
  /**
   * Create new instance of ApplePay
   * @param config
   */
  async createApplePay(e = {}) {
    if (a._paymentFinal)
      return Promise.resolve(!1);
    const n = await new _t(this).init(e);
    return n ? (a._instances.push(n), Promise.resolve(n)) : Promise.resolve(!1);
  }
  /**
   * Create new instance of GooglePay
   * @param config
   */
  async createGooglePay(e) {
    if (a._paymentFinal)
      return Promise.resolve(!1);
    const n = await new Ct(this).init(e);
    return n ? (a._instances.push(n), Promise.resolve(n)) : Promise.resolve(!1);
  }
  /**
   * Destroy instance of service (GooglePay & ApplePay)
   * @param instance
   * @private
   */
  destroyInstance(e) {
    let t = -1;
    for (let n = 0; n < a._instances.length; n++)
      if ("getId" in e && "getId" in a._instances[n] && e.getId() === a._instances[n].getId()) {
        t = n;
        break;
      }
    return t > -1 ? (a._instances.splice(t, 1), !0) : !1;
  }
  /**
   * Run output callback methods through this proxy
   * @param name
   * @param payload
   * @param callbackFunc
   * @private
   */
  async handlerProxy(e, t, n) {
    let o = "general";
    try {
      if (!n) {
        t != null && t.resolve && t.resolve();
        return;
      }
      switch (e) {
        case "onClick":
          if (this.showOverlay(), a._simpleDirector === "transid")
            o = "onClick - by transId", n(t);
          else {
            o = "onClick - requirePayment handler";
            try {
              await this.handleOnRequirePayment(t, n);
            } catch (i) {
              this.hideOverlay(), "reject" in t && t.reject(), this.invalidatePayment(), this.emitError("Error during onRequirePayment: " + (i == null ? void 0 : i.message), "on-require-payment", 45456, i, {
                part: o,
                name: e,
                payload: t
              }), i instanceof u || this.logError("Error during onRequirePayment", "on-require-payment", 45456, { part: o, name: e, payload: t, error: i });
            }
          }
          break;
        case "onPaid":
        case "onCancelled":
        case "onPending":
        case "onError":
          o = e, this.hideOverlay(), n(t);
          break;
        default:
          this.hideOverlay(), o = e, "reject" in t && t.reject(), this.logError(`Invalid functionProxyHandler name: ${e}`, "handler-proxy", 5458, { name: e, payload: t });
      }
    } catch (i) {
      this.hideOverlay(), "reject" in t && t.reject(), this.invalidatePayment(), this.emitError("Invalid handler emitted.", "handler-proxy", 58456, i, {
        part: o,
        name: e,
        payload: t
      });
    }
  }
  /**
   * Create and show overlay
   */
  showOverlay() {
  }
  /**
   * Hide overlay
   */
  hideOverlay() {
  }
  /**
   * Proccess onRequirePayment handler
   * @param payload
   * @param callbackFunc
   * @private
   */
  async handleOnRequirePayment(e, t) {
    var E;
    if (a._invalidateRequestedPaymentId === !1) {
      t(e);
      return;
    }
    let n = !1;
    const o = new Promise((p, G) => {
      t({ resolve: p, reject: G });
    }), i = new Promise((p, G) => {
      a.onRequirePayment({ resolve: p, reject: G, eshopRequest: this.eshopRequest });
    }), s = await Promise.all([o, i]).catch(() => {
      n = !0;
    });
    if (n || !s) {
      if (this.hideOverlay(), !s)
        throw console.log("XXX", s, n), new u("Invalid response from onClick or onRequirePayment.");
      e.reject();
      return;
    }
    let l = null;
    if (typeof s[1] != "object" || !("transactionId" in s[1]))
      throw new u("Invalid onRequirePayment data.", {
        data: s[1]
      });
    if (l = (E = s[1]) == null ? void 0 : E.transactionId, !this.testTransactionId(l))
      throw new u("Invalid transactionID.", {
        transId: l,
        data: s[1]
      });
    const c = await We(a.checkoutId, l).catch((p) => {
      throw new u("Cannot fetch payment data. Payment probably does not exist.", p);
    });
    (c == null ? void 0 : c.test) === !0 && console.warn("Comgate Checkout: Payment in TEST mode used.");
    const m = a.transactionId, h = a.price, d = a.currency, P = a.country, U = a.lang;
    if (this.persistPaymentData(c, l), a._paymentFinal === !0) {
      e.reject();
      return;
    }
    this.valueUpdate("transactionId", m, l), this.valueUpdate("price", h, c.price), this.valueUpdate("currency", d, c.currency), this.valueUpdate("country", P, c.country), this.valueUpdate("locale", U, c.lang), a.transactionId = l, a._invalidateRequestedPaymentId = !1, setTimeout(() => {
      e.resolve();
    }, 25);
  }
  /**
   * Get current app version
   */
  version() {
    return M._version;
  }
  emitError(e, t, n, o, i) {
    const s = {
      service: "checkout",
      message: e,
      scope: t
    };
    n && (s.error = n), o && (s.detail = o), i && (s.params = i), a.onError && typeof a.onError == "function" ? a.onError(s) : console.error("Checkout error:", s);
  }
  /**
   * Log error to our server
   * @param message
   * @param source
   * @param code
   * @param context
   * @private
   */
  logError(e, t, n, o) {
    const i = {
      message: e,
      source: t,
      code: n,
      context: o
    };
    f.error(i);
  }
};
/**
 * Application version
 */
v(M, "_version", {
  version: He
  // revision: "dev"?.toUpperCase() ?? 'ERR',
  // branch: "dev"?.toUpperCase() ?? 'ERR',
});
let x = M;
function Et() {
  Z({
    id: "cg-prefetch-gpay",
    elementType: "link",
    rel: "prefetch",
    as: "script",
    link: "https://pay.google.com/gp/p/js/pay.js"
  });
}
function Dt(r) {
  return Et(), new x(r).init();
}
function Ut() {
  return x._version;
}
export {
  Ut as ComgateCheckoutVersion,
  Dt as default
};
